var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: !_vm.parcels,
          expression: "!parcels",
        },
      ],
      staticClass: "view-cohort-detail",
    },
    [
      _c("ui-heading", {
        attrs: { title: "Partij volgen", icon: "magicon-jump-right-up" },
      }),
      _c("ui-panel", { staticClass: "cohort-selection" }, [
        _c("div", { staticClass: "status" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v("Wil je een actieve of passieve partij bekijken?"),
          ]),
          _c(
            "div",
            { staticClass: "segmented-control" },
            [
              _c(
                "ui-button",
                {
                  class: { active: _vm.cohortMode == "ACTIVE" },
                  attrs: { type: "bordered", color: "highlight-1" },
                  on: {
                    click: function ($event) {
                      _vm.cohortMode = "ACTIVE"
                    },
                  },
                },
                [_vm._v("Actief")]
              ),
              _c(
                "ui-button",
                {
                  class: { active: _vm.cohortMode == "PASSIVE" },
                  attrs: { type: "bordered", color: "highlight-1" },
                  on: {
                    click: function ($event) {
                      _vm.cohortMode = "PASSIVE"
                    },
                  },
                },
                [_vm._v("Passief")]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "cohort" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Kies een partij")]),
          _c(
            "div",
            { staticClass: "dropdowns-holder" },
            [
              _c("ui-dropdown", {
                attrs: {
                  placeholder: "Perceel",
                  searchable: "",
                  options: _vm.parcelOptions,
                },
                model: {
                  value: _vm.parcelId,
                  callback: function ($$v) {
                    _vm.parcelId = $$v
                  },
                  expression: "parcelId",
                },
              }),
              _c("ui-dropdown", {
                attrs: {
                  placeholder: "Vak",
                  searchable: "",
                  disabled: !_vm.parcelId,
                  options: _vm.sectionOptions,
                },
                model: {
                  value: _vm.sectionId,
                  callback: function ($$v) {
                    _vm.sectionId = $$v
                  },
                  expression: "sectionId",
                },
              }),
              _c("ui-dropdown", {
                attrs: {
                  placeholder: "Cohort",
                  disabled: !_vm.sectionId,
                  options: _vm.cohortOptions,
                },
                model: {
                  value: _vm.cohortId,
                  callback: function ($$v) {
                    _vm.cohortId = $$v
                  },
                  expression: "cohortId",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "create" },
          [
            _c(
              "ui-button",
              {
                attrs: {
                  color: "positive",
                  icon: "magicon-reload-2",
                  disabled: !_vm.parcelId || !_vm.sectionId || !_vm.cohortId,
                  loading: _vm.execute,
                },
                on: {
                  click: function ($event) {
                    _vm.execute = true
                  },
                },
              },
              [_vm._v("Creeër overzicht")]
            ),
          ],
          1
        ),
      ]),
      _vm.cohort
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "spinner",
                  rawName: "v-spinner",
                  value: _vm.execute,
                  expression: "execute",
                },
              ],
            },
            [
              _c("ui-heading", {
                attrs: { level: "2", title: _vm.cohortTitle, icon: "fa-th" },
              }),
              _c(
                "div",
                { staticClass: "data-panels" },
                [
                  _c("ui-panel", { staticClass: "state-info" }, [
                    _c("span", { staticClass: "key" }, [_vm._v("Status")]),
                    _vm.cohort.active
                      ? _c("span", { staticClass: "value active" }, [
                          _vm._v("Op perceel"),
                        ])
                      : _c("span", { staticClass: "value passive" }, [
                          _vm._v("Niet op perceel"),
                        ]),
                  ]),
                  _c("ui-panel", { staticClass: "parcel-info" }, [
                    _c("span", { staticClass: "key" }, [_vm._v("Perceel")]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.cohort.section.parcel.alias ||
                            `${_vm.cohort.section.parcel.parcelLocation.name} ${_vm.cohort.section.parcel.parcelLocation.number}`
                        )
                      ),
                    ]),
                  ]),
                  _c("ui-panel", { staticClass: "section-info" }, [
                    _c("span", { staticClass: "key" }, [_vm._v("Vak")]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.cohort.section.name)),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "ui-panel",
                { staticClass: "history", attrs: { padding: false } },
                [
                  _c("h2", [
                    _c("i", { staticClass: "fa-clock-o" }),
                    _vm._v("Historie"),
                  ]),
                  _c(
                    "ui-table",
                    { staticClass: "action-table", attrs: { clickable: "" } },
                    [
                      _c(
                        "ui-table-header",
                        [
                          _c("ui-th", { attrs: { weight: "1.5" } }, [
                            _vm._v("Datum"),
                          ]),
                          _c("ui-th", { attrs: { weight: "2" } }, [
                            _vm._v("Actie"),
                          ]),
                          _c("ui-th", { attrs: { weight: "1" } }, [
                            _vm._v("Bruto"),
                          ]),
                          _c("ui-th", { attrs: { weight: "1" } }, [
                            _vm._v("Netto"),
                          ]),
                          _c("ui-th", { attrs: { weight: "1" } }, [
                            _vm._v("Gewicht"),
                          ]),
                          _c("ui-th", { attrs: { weight: "1" } }, [
                            _vm._v("Tarra"),
                          ]),
                          _c("ui-th", { attrs: { weight: "1" } }, [
                            _vm._v("Bustal"),
                          ]),
                          _c("ui-th", { attrs: { weight: "1" } }, [
                            _vm._v("Stukstal"),
                          ]),
                          _c("ui-th", { attrs: { weight: "1" } }),
                        ],
                        1
                      ),
                      _vm._l(_vm.getActions(_vm.cohort), function (action) {
                        return _c(
                          "ui-tr",
                          {
                            key: action.__typename + ":" + action.id,
                            attrs: {
                              total: _vm.cohort.actions.length,
                              click: "detail",
                            },
                          },
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("date")(action.date, "DD-MM-YYYY")
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("actionTypeTitle")(
                                    action.__typename,
                                    action
                                  )
                                )
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                action.brutoWeight
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("number")(action.brutoWeight)
                                        ) + " mTon"
                                      ),
                                    ]
                                  : [_vm._v("-")],
                              ],
                              2
                            ),
                            _c(
                              "td",
                              [
                                action.nettoWeight
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("number")(action.nettoWeight)
                                        ) + " mTon"
                                      ),
                                    ]
                                  : [_vm._v("-")],
                              ],
                              2
                            ),
                            _c(
                              "td",
                              [
                                action.brutoWeight
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("number")(
                                            action.brutoWeight * 100
                                          )
                                        ) + " kg"
                                      ),
                                    ]
                                  : [_vm._v("-")],
                              ],
                              2
                            ),
                            _c(
                              "td",
                              [
                                action.tarra
                                  ? [
                                      _vm._v(
                                        _vm._s(_vm._f("number")(action.tarra)) +
                                          "%"
                                      ),
                                    ]
                                  : [_vm._v("-")],
                              ],
                              2
                            ),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("empty")(
                                    _vm._f("number")(action.bustal)
                                  )
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("empty")(
                                    _vm._f("number")(action.stukstal)
                                  )
                                )
                              ),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass: "actions",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("ui-link", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Details",
                                      expression: "'Details'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "entypo-eye",
                                    action: "detail",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openActionDetailModal(
                                        action,
                                        _vm.cohort
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }